import { createApp } from 'vue'
import Home from './pages/Home.vue'

createApp(Home).mount('#app')
